module.exports = __webpack_public_path__ + "img/Card_club_J.ecf9c4d5.svg";